// import Highcharts from "highcharts/highstock";
import CAMCFundFiveDebt from "./camc-fund-five-debt";

class WebsiteFundFiveDebt extends CAMCFundFiveDebt {
    constructor(fundCode) {
        super(fundCode);
        this.$root = $(".tabs-content-amc.top-five-debt");
    }
    setEmptyMessage(target = "#top-five-debt-container", emptyMessage = "暂无数据显示") {
        let $targetObj = this.$root.find(target);
        if ($targetObj) {
            $targetObj.empty();
            $targetObj.append(`<div class="api-messaging-content grid-x align-center-middle">${emptyMessage}</div>`);
        }
    }

    errorHandler() {
        showApiMessageing(null);
        this.setEmptyMessage("#top-five-debt-container");
    }

    updateFundDate(date) {
        this.$root.find(".container-updatetime-portfolio").text("数据截止日期：" + date);
    }

    generateBondChart(bondDataArray) {
        var $legend = this.$root.find("#top-five-debt-container-table").empty();
        if ($legend.length && bondDataArray.length) {
            this.$root.find(".tabs-content-amc__table").removeClass("hide");
            let headerItem = `
                <div class="grid-x item-title">
                    <div class="cell small-2 large-3 series">序号</div>
                    <div class="cell small-2 medium-3 series series__title">债券代码</div>
                    <div class="cell small-2 large-3 series series__title">债券名称</div>
                    <div class="cell small-4 series series__title--mobile">债券名称/代码</div>
                    <div class="cell small-2 medium-4 large-3 series series__percent">占基金资产净值比例</div>
                </div>
            `;
            $legend.append(headerItem);
            bondDataArray.forEach(function (element, index) {
                let contentItem = `
                    <div class="grid-x item">
                            <div class="cell small-2 large-3 series">${index + 1}</div>
                            <div class="cell small-2 medium-3 series series__item">${
                                element.securitiesCode || "-"
                            }</div>
                            <div class="cell small-6 medium-5 large-3 series series__item">${element.name}</div>
                            <div class="cell small-8 series series__item--mobile">
                                <div class="complex__item">${element.name}</div>
                                <div class="complex__item">${element.securitiesCode || "-"}</div>
                            </div>
                            <div class="cell small-2 large-3 series series__item--percent text-right">
                                ${Highcharts.numberFormat(element.fundWt).replace(",", " ")}%
                            </div>
                    </div>
                `;
                $legend.append(contentItem);
            });
        } else {
            $legend.remove();
            if (this.reportTime) {
                this.setEmptyMessage(".empty-message", "<span>本基金本报告期末</span><span>未持有债券</span>");
            } else {
                this.setEmptyMessage(".empty-message");
            }
        }
    }
}

$(function () {
    if (window.fundCode && $(".fund-portfolio-div .top-five-debt").length) {
        const camcundFiveDebt = new WebsiteFundFiveDebt(window.fundCode);
        camcundFiveDebt.render();
    }
});
